import {
  COMPLETED,
  LOADING,
  UNINITIALIZED,
  ERROR,
  BROKER_PRODUCTS
} from '../store/actions/types';

const initialState = {
    status: UNINITIALIZED, 
    data: undefined 
  };

export default (state = initialState, action) => {
  switch (action.type) {
    case `${BROKER_PRODUCTS}_${COMPLETED}`:
      return {
        ...state,
        status: COMPLETED,
        data: action.payload,
      };
    case `${BROKER_PRODUCTS}_${LOADING}`:
      return {
         ...state,
        status: LOADING,
        data: undefined,
      };
    case `${BROKER_PRODUCTS}_${UNINITIALIZED}`:
      return {
         ...state,
        status: UNINITIALIZED,
        data: undefined,
      };
    case `${BROKER_PRODUCTS}_${ERROR}`:
      return {
         ...state,
        status: ERROR,
        data: undefined,
      };
    default:
      return state;
  }
}
